<template>
<div class="menu-item" v-bind:class="{'active': currentItem==title}" v-on:click="selectedAct" @mouseover="isOpen = true" @mouseleave="isOpen = false">
  <router-link :to="{path: titleLink}">{{ title }}</router-link>
  <transition name="fade" appear>
    <div class="sub-menu" v-if="isOpen">
      <div v-for="(item, i) in items" :key="i" class="menu-item">
        <router-link :to="{path: titleLink+''+item.link}">{{ item.title }}</router-link>
      </div>
    </div>
  </transition>
</div>
</template>

<script>
export default {
  name: 'dropdown',
  props: ['title','currentItem','titleLink', 'items'],
  data() {
    return {
      isOpen: false,
      menuItemClass:true
    }
  },
  methods:{
    selectedAct:function(){
      /*this.isOpen = !this.isOpen;
      console.log("点击前当前导航页："+this.Global.siteDefaultNav);
      this.Global.siteDefaultNav=this.title;
      console.log("点击后当前导航页："+this.Global.siteDefaultNav);
      console.log("当前导航页："+this.title);*/
      this.$emit("clickItem",{title:this.title});
    }
  }
}
</script>

<style>
nav .menu-item svg {
  width: 10px;
  margin-left: 10px;
}

nav .menu-item .sub-menu {
  position: absolute;
  background-color: #f1a100;
  top: calc(100% + 0px);
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  border-radius: 0px 0px 2px 2px;
}

.sub-menu.menu-item.active,
.sub-menu .menu-item:hover {
  background-color: #666;
  border-bottom-color: #FF5858;
}

.fade-enter-active,
.fade-leave-active {
  transition: all .5s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/NavbarDropdown.vue